import DisplayLogo from '@components/Logo/DisplayLogo';
import { useMediaQuery } from '@styles/useMediaQuery';
import { FC } from 'react';
import AvisPartial from '../AvisPartial';
import ArrowBackground from './ArrowBackground';
import Avis from './Avis';
import { adviser, features, nextSteps } from './domain';
import * as styles from './index.css';
import Intro from './Intro';

interface Props {
  progressPercent: number;
  className?: string;
}

const Presentation: FC<Props> = ({ progressPercent, className }) => {
  const isDesktop = useMediaQuery() === 'desktop';
  const isFirstHalf = progressPercent < 51;

  const presentationClassName = [className, styles.presentation]
    .filter(Boolean)
    .join(' ');

  if (isDesktop) {
    return (
      <div className={presentationClassName}>
        <div className={styles.leftColumnLayoutDiv}>
          <div className={styles.logoHorizontalDiv}>
            <DisplayLogo />
          </div>
          <div className={styles.fullWidthDiv}>
            {isFirstHalf ? (
              <>
                <Avis />
                <AvisPartial />
              </>
            ) : (
              <Intro items={nextSteps} />
            )}
          </div>
        </div>
        <ArrowBackground className={styles.arrowBackground} />
      </div>
    );
  }

  return (
    <div className={presentationClassName}>
      {isFirstHalf ? (
        <>
          <p className={styles.reassuranceText}>
            + de 130 000 apprenants nous font confiance
          </p>
          <AvisPartial />
          <Intro items={features} />
        </>
      ) : (
        <>
          <p className={styles.reassuranceText}>
            Voici ce qui vous attend après avoir rempli notre formulaire :
          </p>
          <Intro items={[adviser]} />
        </>
      )}
    </div>
  );
};

export default Presentation;
